import React, { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import type { PriceChangeFilterInput } from "@/graphql/codegen/graphql"
import { useGetProductsLookup } from "@/screens/Pricing/hooks/useGetProductsLookup"

interface SpecificProductFilterChipsProps {
  selectedProducts: string[]
  onRemove: (key: keyof PriceChangeFilterInput, value?: string) => void
}

const SpecificProductFilterChips: React.FC<SpecificProductFilterChipsProps> = ({ selectedProducts, onRemove }) => {
  const { products } = useGetProductsLookup({ query: "", productIds: selectedProducts })

  const specificProducts = useMemo(
    () => products.filter((product) => selectedProducts.includes(product.id)),
    [selectedProducts, products]
  )

  return (
    <>
      {specificProducts.map((specificProduct) => (
        <FilterChip
          key={`price-change-specific-product-filter-chip`}
          label={`Specific Product: ${specificProduct.label}`}
          onDelete={() => onRemove("specificProductIds", specificProduct.id)}
        />
      ))}
    </>
  )
}

export default SpecificProductFilterChips
